import { useEffect } from "react";
import { useCmsContent } from "./use-cms-content";

const setIconLink = (rel: string, href: string) => {
  const links = Array.from(
    document.querySelectorAll<HTMLLinkElement>(`link[rel='${rel}']`)
  );
  if (links.length === 0) {
    const link = document.createElement("link");
    link.rel = rel;
    link.type = "image/png";
    link.href = href;
    document.head.appendChild(link);
    return;
  }
  links.forEach((link) => {
    link.type = "image/png";
    link.href = href;
  });
};

/**
 * Dynamically updates the browser tab favicon and title
 * based on CMS settings (favicon_url and page_title).
 * Used globally so admin/login/PDV pages also reflect the CMS icon.
 */
export const useFaviconTitle = () => {
  const { content, loading } = useCmsContent();

  useEffect(() => {
    if (loading) return;

    if (content.page_title) {
      document.title = content.page_title;
    }

    if (content.favicon_url) {
      const href = String(content.favicon_url);
      setIconLink("icon", href);
      setIconLink("shortcut icon", href);
      setIconLink("apple-touch-icon", href);
    }
  }, [content, loading]);
};
